import React from "react";
import { useTranslation } from "react-i18next";
import { useSettings } from "@/contexts/SettingsContext";
import { Banknote, Wifi, CreditCard, Smartphone } from "lucide-react";

// Brand badges: render as simple typography tiles (no external SVG dependencies).
const META = {
  cash:        { icon: Banknote,   brand: false },
  contactless: { icon: Wifi,       brand: false },
  mastercard:  { icon: CreditCard, brand: true, color: "#EB001B" },
  visa:        { icon: CreditCard, brand: true, color: "#1A1F71" },
  apple_pay:   { icon: Smartphone, brand: true, color: "#F8F5EF" },
  maestro:     { icon: CreditCard, brand: true, color: "#0099DF" },
};

export default function Payments({ compact = false }) {
  const { t } = useTranslation();
  const { settings: s } = useSettings();
  const methods = s?.payment_methods || [];
  if (!methods.length) return null;

  return (
    <div data-testid="payments-block" className={compact ? "" : "py-6"}>
      {!compact && (
        <>
          <div className="overline">{t("payments.overline")}</div>
          <h3 className="font-serif-luxe text-3xl text-[#F8F5EF] mt-2 mb-6">{t("payments.title")}</h3>
        </>
      )}
      <ul className="flex flex-wrap gap-3" data-testid="payments-list">
        {methods.map(m => {
          const meta = META[m] || { icon: CreditCard, brand: false };
          const Icon = meta.icon;
          return (
            <li key={m} data-testid={`payment-${m}`} className="luxe-card flex items-center gap-3 px-4 py-3">
              <Icon size={16} style={meta.brand ? { color: meta.color } : { color: "#D4AF37" }} />
              <span className="text-sm text-[#F8F5EF]/85">{t(`payments.${m}`)}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
